module.exports = __webpack_public_path__ + "img/battle-wiki-x.6aaa545b.png";